import { classnames } from 'tailwindcss-classnames';
import { TextField } from '@sitecore-jss/sitecore-jss-react';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

interface CaptionPanelProps {
  field: TextField;
}

const CaptionPanel = ({ field }: CaptionPanelProps): JSX.Element => {
  const isExperienceEditor = useExperienceEditor();
  // If we are not running in a designer the field is null or has an empy value then exit
  if (!isExperienceEditor && (field?.value ?? '').toString().length === 0) {
    return <></>;
  }
  // Caption container classes
  const captionContainer = classnames('mx-auto', 'p-4', 'grid', 'grid-cols-1', 'text-theme-text');
  // Text classes
  const textClasses = classnames('italic', 'text-sm', 'pl-4');
  // Gradient bar
  const gradientBar = classnames(
    'caption-panel-bg',
    'w-0.5',
    'h-full',
    'float-left',
    'bg-gradient-to-b',
    'from-blue',
    'to-green'
  );
  // Return caption container
  return (
    <>
      <div className={classnames(captionContainer)}>
        <div>
          <div className={classnames(gradientBar)}>&nbsp;</div>
          <Text field={field} className={classnames(textClasses)} tag="p" />
        </div>
      </div>
    </>
  );
};

export default CaptionPanel;
